/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./SuccessPayment.css";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme, useMediaQuery } from "@mui/material";

import Loader from "./Loader/Loader";
import TagManager from "react-gtm-module";
import SuccessPage from "./SuccessPage";
import ErrorPage from "./ErrorPage";
import { appStoreLink, playStoreLink } from "./utils/constant";

const SuccessPayment = () => {
  const { transactionId } = useParams();
  const [referralLink, setReferralLink] = useState();
  const [paymentDetails, setPaymentDetails] = useState({});
  const {
    REACT_APP_URL,
    REACT_APP_ONBOARDING_REDIRECT_URL,
    REACT_APP_CHECKOUT_URL,
    REACT_APP_STUDENTPORTAL_URL,
  } = process.env;
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${REACT_APP_URL}/checkPayment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ paymentId: transactionId }),
      });
      if (!response.ok) {
        throw new Error("Something went Wrong");
      }

      const data = await response.json();
      setLoading(false);
      setReferralLink(data?.referralUrl);
      setPaymentDetails(data);
      successPageGTM(data?.parentContact);
    } catch (error) {
      setLoading(false);
    }
  };

  // const submitOnboardingRequest = async () => {
  //   try {
  //     // This is not applicable for catalyst
  //     if (businessUnitId == 2) {
  //       return;
  //     }
  //     setLoading(true);
  //     setShowRedirectPopup(true);
  //     const response = await fetch(`${REACT_APP_URL}/student/onboarding`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //       body: JSON.stringify({ paymentId: transactionId, onPaymentSuccess: 1 }),
  //     });
  //     if (response.ok) {
  //       const data = await response.json();
  //       setTimeout(() => {
  //         window.location.href =
  //           REACT_APP_ONBOARDING_REDIRECT_URL +
  //           "/onboarding/" +
  //           data?.requestId;
  //       }, 1500);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };

  const successPageGTM = (parentContact) => {
    const tagManagerArgs = {
      gtmId: "GTM-TH4RWGG",
      dataLayer: {
        event: "codeyoung_site",
        event_category: "codeyoung_site",
        event_action: "payment_success",
        event_label: parentContact,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
    TagManager.initialize(tagManagerArgs);
  };

  useEffect(() => {
    getData();
    if (window.localStorage.getItem("orderFlowName") === "liveClasses") {
      window.localStorage.removeItem("orderFlowName");
      window.location.href = `${REACT_APP_CHECKOUT_URL}/liveclasses?showSuccess=true&paymentId=${transactionId}`;
      return;
    } else if (window.localStorage.getItem("orderFlowName") === "buyCredits") {
      window.localStorage.removeItem("orderFlowName");
      window.location.href = `${REACT_APP_STUDENTPORTAL_URL}/#/buy-credits?showSuccess=true&paymentId=${transactionId}`;
      return;
    }
    if (window.opener) {
      window.opener.postMessage(
        "paymentSuccess",
        process.env.REACT_APP_WEBSITE_URL
      );
    }

    //   submitOnboardingRequest();
  }, []);
  if (loading) return <Loader />;
  return (
    <>
      {/* {showRedirectPopup && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            zIndex: 1000,
            textAlign: "center",
            border: "1px solid #e0e0e0",
          }}
        >
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#333",
              marginBottom: "10px",
            }}
          >
            Redirecting...
          </div>
          <div style={{ fontSize: "14px", color: "#666" }}>
            You will be redirected to onboarding shortly
          </div>
        </div>
      )} */}

      {paymentDetails?.tokenAmountStatus === true ? (
         <SuccessPage
          amountPaid={paymentDetails?.paymentAmount}
          dateAndTime={paymentDetails?.paymentDate}
          appStoreLink={appStoreLink}
          playStoreLink={playStoreLink}
          referralLink={referralLink}
          bannerImg={paymentDetails?.banners}
          referralCode={paymentDetails?.referralCode}
          parentId={paymentDetails?.parentId}
        />
      ) : (
        <ErrorPage />
      )}
    </>
  );
};

export default SuccessPayment;
